import { DASHBOARD_TILES, defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";
import { AdminSales30Tile, VendorSales30Tile, VendorSalesTab } from "./pages";

/** Reports (P5-09, optional): admin steps 1 & 19, vendor step 4. */
export const reportsModule = defineModule({
  name: "reports",
  label: "Reports",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
    "logistics",
    "cart",
    "payments",
    "payouts",
    "orders",
  ],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "reports",
        permission: "reports.view_reports",
        page: () => import("./admin/ReportsPage"),
      },
    ],
    nav: [
      {
        id: "reports",
        group: "reports",
        label: "reports:nav.reports",
        icon: "trending",
        to: "/reports",
        permission: "reports.view_reports",
        order: 1,
      },
    ],
    slots: {
      [DASHBOARD_TILES]: [
        {
          id: "sales30",
          permission: "reports.view_reports",
          order: 5,
          component: AdminSales30Tile,
        },
      ],
      // the vendors module's store page (well-known slot "vendor.tabs")
      "vendor.tabs": [
        {
          id: "sales",
          label: "reports:nav.salesTab",
          permission: "reports.view_reports",
          component: VendorSalesTab,
        },
      ],
    },
  },
  vendor: {
    routes: [
      { path: "reports", permission: "orders.manage", page: () => import("./vendor/ReportsPage") },
    ],
    nav: [
      {
        id: "reports",
        group: "sales",
        label: "reports:nav.reports",
        icon: "trending",
        to: "/reports",
        permission: "orders.manage",
        order: 40,
      },
    ],
    slots: {
      [DASHBOARD_TILES]: [
        { id: "sales30", permission: "orders.manage", order: 3, component: VendorSales30Tile },
      ],
    },
  },
});
